const sliderImg = [
  { id: 1, src: '/img/slider-img-1.jpg', alt: '과일 사진' },
  { id: 2, src: '/img/slider-img-2.jpg', alt: '피자 사진' },
  { id: 3, src: '/img/slider-img-3.jpg', alt: '햄버거 사진' },
  { id: 4, src: '/img/slider-img-4.jpg', alt: '스테이크 사진' },
  { id: 5, src: '/img/slider-img-5.jpg', alt: '일본 라면 사진' },
  { id: 6, src: '/img/slider-img-6.jpg', alt: '비빔밥 사진' },
];

export default sliderImg;
